import React from "react";
import Popover from "../Popover";

export default function NewIndustryPopover() {
  return (
    <Popover triggerText="New Industry">
      <Popover.Title>New Industry</Popover.Title>
      <Popover.Body>
        If you would like to have a new industry added to the list of templates, please email
        <a href="mailto:help@reason.consulting" target="_blank"> help@reason.consulting</a>.
        Please include the name of the industry and whether it is office or home based.
        Any additional information is helpful and appreciated but not required,
        e.g. NAICS code, average number of employees, sample schedule of assets, etc.
      </Popover.Body>
    </Popover>
  );
};
